import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
  contract: ContractSearchResponseDTO;
}

export const ViewConsortiumFormReadOnly = ({ contract }: ViewFormProps) => {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
      <DetailItem label="Grupo Consórcio" value={contract.grupoConsorcio} />
      <DetailItem label="Cota Consórcio" value={contract.cotaConsorcio} />
    </Grid>
  );
};